import { defineWidget } from '../../client/lib/contract/helpers'
import { t } from '../../client/i18n'
import { usageRingsRender } from '../../client/families/usage/renders'

/** OpenCode Go dosage as three small donuts (one per window). */
export default defineWidget({
  id: 'usage-rings',
  name: () => t('widget.usage-rings.name'),
  desc: () => t('widget.usage-rings.desc'),
  builtin: false,
  group: 'opencode-go',
  render: usageRingsRender,
})